exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".body.home h1{color:#fff}nav.sidebar a:focus{outline:3px solid #c19f33!important}.report-download{display:flex;flex-direction:column;width:100%}.report-download h5{margin-bottom:10px;font-size:14px;font-weight:800;color:#6b6b6b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/MyReceipts/ReportDownload.scss
// module id = 892
// module chunks = 0